module.exports = __webpack_public_path__ + "static/budget-89bc4fd73c22148ed15d9bc18b209dae.png";